import initialState from './initialstate';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function SyncStateReducer(
	state = initialState.syncState,
	action
) {
	switch (action.type) {
		case 'SET_SYNC_STATE':
			return action.syncState;
		default:
			return state;
	}
}
